import { render } from "./InputOnOffPill.vue?vue&type=template&id=bb312e28&scoped=true"
import script from "./InputOnOffPill.vue?vue&type=script&lang=js"
export * from "./InputOnOffPill.vue?vue&type=script&lang=js"

import "./InputOnOffPill.vue?vue&type=style&index=0&id=bb312e28&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb312e28"]])

export default __exports__